import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Toast } from 'primereact/toast';
import { translatedMessage } from '../../service/LanguageService';
import { CompetitionService } from '../../service/CompetitionService';
import useNavProps from '../../hooks/useNavProps';
import CompetitionToolbar from './CompetitionToolbar';
import CompetitionUtils from '../../utilities/CompetitionUtils';
import SecurityService from '../../service/SecurityService';
import { Checkbox } from 'primereact/checkbox';

const CompetitionDocument = () => {
    const [competition, setCompetition] = useState(null);
    const [documentList, setDocumentList] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [hasEditPermission, setHasEditPermission] = useState(false);
    // const [selectedValue, setSelectedValue] = useState(null);
    // const [showAddDialog, setShowAddDialog] = useState(false);
    // const [showDeleteDialog, setShowDeleteDialog] = useState(false);

    const toast = useRef(null);

    const competitionService = useMemo(() => new CompetitionService(), []);

    const { competitionIdParam } = useParams();

    const { setNavPropsValue } = useNavProps();

    useEffect(() => {
        setIsLoading(true);

        const checkEditPermission = async () => {
            setHasEditPermission(await SecurityService.check('CAN_EDIT_JOB_COMPETITION', competitionIdParam));
        };

        const getCompetition = async () => {
            await competitionService.getCompetition(competitionIdParam)
                .then(async (competitionData) => {
                    // console.log(competitionData);
                    setCompetition(competitionData);

                    setNavPropsValue('competition-job', competitionData.id, competitionData.name)

                    getDocuments();
                })
                .catch((error) => toast?.current?.show({ severity: 'error', summary: translatedMessage(error), life: 5000 }));
        };

        checkEditPermission();
        getCompetition();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [competitionService, competitionIdParam]);

    const getDocuments = async () => {
        await competitionService.getCompetitionDocumentList(competitionIdParam)
            .then((_docList) => {
                // console.log("_docList: ", _docList);
                setDocumentList(_docList);
                setIsLoading(false);
            })
            .catch((error) => error && toast?.current?.show({ severity: 'error', summary: translatedMessage(error), life: 5000 }));
    };

    // const handleNew = () => {
    //     setSelectedValue(null)
    //     setShowAddDialog(true)
    // }

    // const handleEdit = (data) => {
    //     // console.log("handleEdit: ", data);
    //     setSelectedValue(data)
    //     setShowAddDialog(true)
    // }

    // const handleDelete = (data) => {
    //     setSelectedValue(data)
    //     setShowDeleteDialog(true)
    // }

    // const afterSave = (savedCompetitionDocument, success, error) => {
    //     if (success) {
    //         getDocuments();
    //         toast?.current?.show({ severity: 'success', summary: translatedMessage('generic.save.success') });
    //     } else {
    //         toast?.current?.show({ severity: 'error', summary: translatedMessage(error), life: 5000 });
    //     }
    // };

    // const deleteRecord = () => {
    //     competitionService.deleteCompetitionDocument(selectedValue.id)
    //         .then(() => {
    //             getDocuments()
    //             setShowDeleteDialog(false);

    //             toast?.current?.show({ severity: 'success', summary: translatedMessage("generic.delete.success") });
    //         })
    //         .catch(error => {
    //             toast?.current?.show({ severity: 'error', summary: translatedMessage(error), life: 5000 });
    //         })
    // };

    const handleCheckChange = (event, item) => {
        // console.log(event.target.checked)
        // console.log(item)
        if (event.target) {
            item.required = event.target.checked
            competitionService.saveCompetitionDocument(item)
                .then(savedDocument => {
                    getDocuments()
                    toast?.current?.show({ severity: 'success', summary: translatedMessage("generic.save.success") });
                })
                .catch(error => {
                    toast?.current?.show({ severity: 'error', summary: translatedMessage(error), life: 5000 });
                });
        }
    }

    if (isLoading) {
        return (
            <div className="w-full flex align-items-center">
                <Toast ref={toast} />
                <ProgressSpinner />
            </div>
        );
    } else {
        return (
            <>
                <Toast ref={toast} />
                <div className="grid h-full">
                    <div className="col-12">
                        <div className="card h-full">
                            <CompetitionToolbar competition={competition} code="DOCUMENT" />

                            <div className='col-12 mb-3'>
                                {/* <div>
                                    <Button
                                        label={translatedMessage('generic.file.add')}
                                        icon="pi pi-plus"
                                        className="pcn-button-slim-with-icon p-button-primary"
                                        onClick={handleNew}
                                        visible={hasEditPermission}
                                        disabled={!CompetitionUtils.canEdit(competition)}
                                    />
                                </div>
                                <Divider /> */}
                                <h5 className='mb-3'>{translatedMessage("competition.document.title")}</h5>

                                {documentList && documentList.length > 0 &&
                                    documentList.map((item, index) => (
                                        <div key={index} className='flex align-items-center mb-3'>
                                            <div className="field-checkbox text-left mb-0">
                                                <Checkbox inputId="required" name="required" checked={item?.required} 
                                                    disabled={!hasEditPermission || !CompetitionUtils.canEdit(competition)}
                                                    onChange={(e) => handleCheckChange(e, item)} />
                                                <label htmlFor="required">{item.document}</label>
                                            </div>

                                            {/* {!item.nomCompetitionDocument && <>
                                                <Button
                                                    className="pcn-button-icon p-button-icon-only text-primary background-transparent ml-2"
                                                    onClick={() => handleEdit(item)}
                                                    visible={hasEditPermission}
                                                >
                                                    <FontAwesomeIcon icon='fa-solid fa-pencil' />
                                                </Button>

                                                <Button
                                                    className="pcn-button-icon p-button-icon-only text-danger background-transparent ml-2"
                                                    onClick={() => handleDelete(item)}
                                                    visible={hasEditPermission}
                                                >
                                                    <FontAwesomeIcon icon='fa-solid fa-trash' />
                                                </Button>
                                            </>} */}
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                </div>

                {/* {showAddDialog &&
                    <CompetitionDocumentEditDialog
                        competition={competition}
                        competitionDocument={selectedValue}
                        visible={showAddDialog}
                        afterSave={afterSave}
                        onClose={() => setShowAddDialog(false)}
                    />
                } */}

                {/* {showDeleteDialog &&
                    <DeleteModalComponent
                        visible={showDeleteDialog}
                        item={selectedValue && selectedValue.institutionName}
                        closeDialog={() => setShowDeleteDialog(false)}
                        deleteRecord={() => deleteRecord()}
                    />
                } */}
            </>
        );
    }
};

export default CompetitionDocument;
